import ArrowBackRounded from "@mui/icons-material/ArrowBackRounded";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useNavigate, useOutletContext } from "react-router-dom";
import { reportsDashboardSideNavList } from "./data";
import PictorialST from "./DashboardComponents/PictorialST/PictorialST";
import Home from "./DashboardComponents/Home/Home";
import { CustomLinearProgress } from "components/ReusableComponents/CustomLinearProgress/CustomLinearProgress";
import RareBoxLogo from "Logos/RareBoxLogo";
import { ReportsState } from "context/ReportsContext";
import SaleSummary from "./DashboardComponents/SaleSummary/SaleSummary";
import SoTracker from "./DashboardComponents/SoTracker/SoTracker";
import ShopifyLiveSale from "./DashboardComponents/ShopifyLiveSale/ShopifyLiveSale";
import { useEffect, useState } from "react";
import { services, rootProtectedPath } from "data/authData";
import { Breadcrumbs } from "@mui/material";
import { grey } from "@mui/material/colors";
import AopTracker from "./DashboardComponents/AopTracker/AopTracker";

const Reports = () => {
	const [currentPath, service] = useOutletContext();
	const { reportLoading } = ReportsState();
	const [serviceDisplayname, setServiceDisplayName] = useState();

	useEffect(() => {
		const url = window.location.pathname;
		console.log(url, url?.split(`/${rootProtectedPath}/${services.reports.path.split("/")[0]}/`)?.[1], "sdjfbzdn,");
		setServiceDisplayName(url?.split(`/${rootProtectedPath}/${services.reports.path.split("/")[0]}/`)?.[1] ?? service.name);
		console.log();
	}, [service]);
	const navigate = useNavigate();

	const tabComponents = {
		[reportsDashboardSideNavList.HOME.key]: {
			...reportsDashboardSideNavList.HOME,
			component: <Home />,
		},
		[reportsDashboardSideNavList.aop_tracker.key]: {
			...reportsDashboardSideNavList.aop_tracker,
			component: <AopTracker />,
		},
		[reportsDashboardSideNavList.SALE.types.summary.key]: {
			...reportsDashboardSideNavList.SALE.types.summary,
			component: <SaleSummary />,
		},
		[reportsDashboardSideNavList.SALE.types.shopify_live_sale.key]: {
			...reportsDashboardSideNavList.SALE.types.shopify_live_sale,
			component: <ShopifyLiveSale />,
		},
		[reportsDashboardSideNavList.EFFICENCY.types.PICTORIAL_ST.key]: {
			...reportsDashboardSideNavList.EFFICENCY.types.PICTORIAL_ST,
			component: <PictorialST />,
		},
		[reportsDashboardSideNavList.EFFICENCY.types.SO_TRACKER.key]: {
			...reportsDashboardSideNavList.EFFICENCY.types.SO_TRACKER,
			component: <SoTracker />,
		},
	};

	return (
		<Box sx={{ width: "100%", p: 1, pt: 0, boxSizing: "border-box" }}>
			<Box display="flex" alignItems="center" columnGap={1}>
				<IconButton onClick={() => navigate(-1)}>
					<ArrowBackRounded />
				</IconButton>
				<Breadcrumbs>
					{serviceDisplayname
						?.split("/")
						.reduce((acc, row, i, arr) => {
							if (i !== arr.length - 1)
								acc.push(
									<Typography sx={{ color: grey[600] }} variant="h6" fontSize={18} textTransform="capitalize">
										{row.toLowerCase().split("_")?.join(" ")}
									</Typography>
								);
							return acc;
						}, [])
						.map((row) => row)}
					<Typography sx={{ color: "text.primary" }} variant="h6" fontSize={18} textTransform="capitalize">
						{service.name}
					</Typography>
				</Breadcrumbs>
				{/* <Typography variant="h5">{service?.name}</Typography> */}
			</Box>

			<Box
				width="100%"
				height="100%"
				display="flex"
				alignItems="center"
				justifyContent="center"
				sx={{ display: reportLoading ? "block" : "none" }}>
				<div
					style={{
						width: "200px",
						position: "absolute",
						left: "50%",
						top: "50%",
						transform: "translate(-50%,-50%)",
					}}>
					<RareBoxLogo />
					<CustomLinearProgress />
				</div>
			</Box>
			<Box
				width="100%"
				height="100%"
				display="flex"
				alignItems="center"
				justifyContent="center"
				sx={{ display: reportLoading ? "none" : "block" }}>
				{tabComponents?.[currentPath]?.component}
			</Box>
		</Box>
	);
};

export default Reports;
